export var VERSION = '1.14.4';
//# sourceMappingURL=version.js.map